const LeftSideGroupArrowIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={"1em"}
        height={"1em"}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="22"
          height="22"
          rx="11"
          transform="matrix(1 0 0 -1 0 22)"
          fill="#455468"
        />
        <path
          d="M7 6.63379L10.3467 10.8172L7 15.0007"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.0195 6.63379L15.3663 10.8172L12.0195 15.0007"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default LeftSideGroupArrowIcon;
